import merge from 'merge';
import vstuiBase from 'config/themes/vstuibase';
import {
  createStartAction,
  createSuccessAction,
} from 'app/api/redux-util/async-helpers';
import {
  getBrand,
  hasBrandError,
} from 'app/api/redux-watson/watson-config-selectors';
import vstuiColors from 'app/ui/core/vstui/color-extender';
import { THEME_KEY } from 'app/api/redux-watson/watson-config-action';
import { noticeError } from 'app/api/analytics/reporting';

function finalizeDefault() {
  return function(dispatch) {
    dispatch(
      finalizeVstuiTheme({
        base: 'jrPurple',
        primary: 'red',
        secondary: 'blue',
        focus: 'orange',
        secondaryStudent: 'jrLegacyGold',
      })
    );
  };
}

function finalizeVstuiTheme(colorMap) {
  return function(dispatch) {
    const colors = convertVstuiColors(colorMap);
    const data = merge.recursive(vstuiBase, { colors });
    dispatch(createSuccessAction(THEME_KEY, data));
  };
}

function finalizeTheme(data) {
  return function(dispatch) {
    dispatch(createSuccessAction(THEME_KEY, data));
  };
}

/**
 * @param config e.g. { primary: "magic", secondary: "cheddar", ...}
 * @return eg. { "vstui-primary-1": "#ff0000", ... }
 */
export function convertVstuiColors(config) {
  const result = {};
  Object.keys(config).forEach(k => {
    for (let i = 1; i <= 10; i++) {
      if (config[k]) {
        result[buildKey(k, i)] = vstuiColors[config[k]].getShade(i);
      }
    }
  });
  return result;
}

function buildKey(id, index) {
  return `vstui-${id}-${index}`;
}

export function loadTheme() {
  return async function(dispatch, getState) {
    dispatch(createStartAction(THEME_KEY));

    if (hasBrandError(getState())) {
      return dispatch(finalizeDefault());
    }

    const brandData = getBrand(getState());
    const mode = brandData.common.colors.mode;

    try {
      if (mode === 'custom') {
        const name = brandData.common.colors.custom.name;
        const data = await import(`../../../config/themes/${name}.json`);
        return dispatch(finalizeTheme(data));
      } else if (mode === 'vstui') {
        const vstuiChoices = brandData.common.colors.vstui;
        return dispatch(
          finalizeVstuiTheme({
            ...vstuiChoices,
            secondaryStudent: vstuiChoices.secondary,
          })
        );
      } else {
        return dispatch(finalizeDefault());
      }
    } catch (e) {
      noticeError(e);
    }

    return dispatch(finalizeDefault());
  };
}



// WEBPACK FOOTER //
// ./src/app/api/redux-watson/theme-actions.js